import Model from 'flarum/common/Model';

export default class StructuredCourse extends Model {}

Object.assign(StructuredCourse.prototype, {
  title: Model.attribute('title'),
  levelCode: Model.attribute('level_code'),
  courseNumber: Model.attribute('course_number'),
  difficulty: Model.attribute('difficulty'),
  studyPeriod: Model.attribute('study_period'),
  swordCost: Model.attribute('sword_cost'),
  coverImage: Model.attribute('cover_image'),
  description: Model.attribute('description'),
  status: Model.attribute('status'),
  sortOrder: Model.attribute('sort_order'),
  articleCount: Model.attribute('article_count'),
  createdAt: Model.attribute('created_at', Model.transformDate),
  updatedAt: Model.attribute('updated_at', Model.transformDate),

  level: Model.hasOne('level'),
  articles: Model.hasMany('articles'),
  creator: Model.hasOne('creator'),
});
